export const NITGPostLoader = () => {
    const buttons = document.querySelectorAll('.tag-filters button');
    const postsContainer = document.getElementById('post-list');
    const sentinel = document.getElementById('scroll-sentinel');
    
    if (!postsContainer || !sentinel || ! window.NITGAjax?.ajax_url) {
        console.warn('[NITGPostLoader] Не найден один из элементов.');
        return;
    }
    
    let currentTag = 'all';
    let currentPage = 1;
    let isLoading = false;
    let hasMore = true;
    let observer;
    const ajaxurl = window.NITGAjax?.ajax_url;
    const nonce = window.NITGAjax?.nonce;
    const mainEl = document.querySelector('main[data-category]');
    const currentCategory = mainEl?.dataset.category || '';
    
    const showSkeletons = () => {
        const count = 3;
        for (let i = 0; i < count; i++) {
            const skel = document.createElement('div');
            skel.className = 'skeleton';
            postsContainer.appendChild(skel);
        }
    };
    
    const clearSkeletons = () => {
        postsContainer.querySelectorAll('.skeleton').forEach(el => el.remove());
    };
    
    const loadPosts = (reset = false) => {
        // if (isLoading || !hasMore) return;
        isLoading = true;
        
        if (reset) {
            currentPage = 1;
            hasMore = true;
            postsContainer.innerHTML = '';
        }
        
        showSkeletons();
        
        const formData = new URLSearchParams();
        formData.append('category', currentCategory);
        formData.append('action', 'filter_posts_by_tag');
        formData.append('nonce', nonce);
        formData.append('tag', currentTag);
        formData.append('paged', currentPage.toString());
        formData.append('category', currentCategory);
        
        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: formData.toString(),
            credentials: 'same-origin',
        })
            .then(res => {
                if (!res.ok) throw new Error('Ошибка запроса');
                return res.text();
            })
            .then(html => {
                const tmp = document.createElement('div');
                tmp.innerHTML = html;
                
                // извлекаем "has more" и контент
                const flag = tmp.querySelector('[data-has-more]');
                hasMore = flag?.getAttribute('data-has-more') === 'true';
                
                const articles = tmp.querySelectorAll('.post-item');
                articles.forEach(article => postsContainer.appendChild(article));
            })
            .catch(err => console.error('[NITGPostLoader] Ошибка:', err))
            .finally(() => {
                clearSkeletons();
                isLoading = false;
                currentPage++;
            });
    };
    
    // debounce (250ms)
    let debounceTimeout;
    const debounceLoad = (fn) => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(fn, 250);
    };
    
    // переключение тега
    if (buttons.length) {
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.classList.contains('full')) return;
                
                buttons.forEach(b => b.classList.remove('full'));
                btn.classList.add('full');
                console.log( btn.dataset)
                currentTag = btn.dataset?.tag || 'all';
                debounceLoad(() => loadPosts(true));
            });
        });
    }
    
    // Бесконечная прокрутка
    observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && !isLoading) {
            loadPosts();
        }
    }, { threshold: 1.0 });
    
    observer.observe(sentinel);
    
    // первая загрузка
    loadPosts(true);
};
